import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { ConditionalWrapper } from "@/utils/helpers";
import { getTagIdFor } from "@/utils/tagging/tag.utils";

import { useProductPageContext } from "../../context/productPage.context";

type ProductDetailTitleProps = {};

const ProductDetailTitleBase = ({
    children
}: RequireChildrenFor<ProductDetailTitleProps>) => {
    const { t } = useGranite();
    const { brandPagePath, product } = useProductPageContext();

    return (
        <div className={cn("tw:relative tw:overflow-hidden tw:mb-4")}>
            <h1
                className={cn("tw:relative tw:mb-2!")}
                {...getTagIdFor("pdp-title")}
            >
                <span className={cn("tw:layer-base/[1] tw:relative")}>
                    {product.productTitle}
                </span>
            </h1>
            <div
                className={cn(
                    "tw:flex-wrap tw:flex-row tw:items-center tw:inline-flex"
                )}
            >
                <div className={cn("tw:flex")}>
                    {brandPagePath && !!product.brand?.name && (
                        <span className={cn("tw:self-end tw:mr-2")}>
                            {t("productDetail.label.brand")}{" "}
                            <ConditionalWrapper
                                condition={!!brandPagePath}
                                wrapper={(children) => (
                                    <a href={brandPagePath}>{children}</a>
                                )}
                            >
                                {product.brand?.name}
                            </ConditionalWrapper>
                        </span>
                    )}
                    <span className={cn("tw:self-end tw:mr-2")}>
                        {t("productDetail.label.skuRef")} {product.sku}
                    </span>
                </div>
                {children}
            </div>
        </div>
    );
};

export { ProductDetailTitleBase };
